/**
 * Shared utility for subscription activation
 * This module provides a throttled function to handle subscription activation requests.
 * Trials are activated from the Subscription Management window (v8ActivateTrial);
 * Free plans upgrade from the pricing page.
 */

import throttle from 'just-throttle';
import { showModal } from "@app/store/modalStore.svelte.js";
import { environment } from "@app/store/envStore.svelte.js";
import { isFreePlan } from "@app/lib/entitlements.js";
import { showUpgradePrompt } from "@app/lib/upgradePrompt.js";

/**
 * Throttled function to activate a subscription: opens Subscription Management,
 * where a trial can be activated, or the upgrade prompt on the Free plan.
 */
const activateSubscription = throttle(async () => {
    console.log("Activating subscription");

    if (isFreePlan() || !environment.online) {
        await showUpgradePrompt();
        return;
    }

    showModal("subscriptionManagement");
}, 10000, { leading: true });

export { activateSubscription };
export default activateSubscription;
